export default "__VITE_ASSET__cMGNzq8d__"